/* Postavka menija "Napake" z numerično značko.
   [PATCH napake-fe v2]

   Lastna komponenta NAMENOMA: `navKoncni` se v DashboardLayout gradi v vrstici 65,
   `location` pa nastane šele v vrstici 74 — vrivanje števca v navKoncni bi zadelo
   v časovno mrtvo cono. Tako komponenta nosi svoje hooke, DashboardLayout pa se
   ne prerazporeja. Zvonec (ObvestilaZvonec) je s tem popolnoma nepovezan.

   Videz je znak za znak enak ostalim postavkam menija (razredi prepisani iz
   DashboardLayout, vrstice 117–131). */
import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import clsx from 'clsx';
import { useNapakeStore } from '../stores/napakeStore';

export function NapakeNavPostavka({ sidebarOpen }: { sidebarOpen: boolean }) {
  const znacka = useNapakeStore((s) => s.znacka);
  const nalozi = useNapakeStore((s) => s.nalozi);
  const location = useLocation();

  /* ob vsaki menjavi rute */
  useEffect(() => { nalozi(); }, [location.pathname, nalozi]);

  /* [PATCH napake-fe v3] anketa 20 s (prej 60 s — zaostanek je bil opazen) */
  useEffect(() => {
    const t = setInterval(() => { nalozi(); }, 20000);
    return () => clearInterval(t);
  }, [nalozi]);

  /* [PATCH napake-fe v3] takojšnja osvežitev ob vrnitvi v zavihek ali okno.
     Brez tega je bilo treba čakati na naslednjo anketo ali osvežiti stran.
     Osvežuje SAMO števec — nič, kar bi lahko prepisalo vnos uporabnika. */
  useEffect(() => {
    const osvezi = () => {
      if (document.visibilityState === 'visible') nalozi();
    };
    window.addEventListener('focus', osvezi);
    document.addEventListener('visibilitychange', osvezi);
    return () => {
      window.removeEventListener('focus', osvezi);
      document.removeEventListener('visibilitychange', osvezi);
    };
  }, [nalozi]);

  return (
    <NavLink to="/napake"
      className={({ isActive }) => clsx(
        'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all',
        isActive
          ? 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400'
          : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white'
      )}>
      <span className="relative flex-shrink-0">
        <AlertTriangle className="w-5 h-5" />
        {!sidebarOpen && znacka > 0 && (
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-blue-500 rounded-full" />
        )}
      </span>
      {sidebarOpen && (
        <>
          <span>Napake</span>
          {znacka > 0 && (
            <span className="ml-auto text-xs bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 px-1.5 py-0.5 rounded-full">
              {znacka}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
}
